import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { useDispatch } from 'react-redux';

import { deleteWeatherNotification } from '../../../actions/event-profile-actions';
import { isOrganizer } from '../../../utils/events';
import { ConfirmActionPopup } from '../../PopUps';

import styles from './weatherNotifications.scss';

const Notification = (props) => {
    const {
        event,
        notification,
        onEditWeatherNotification,
        'data-testid': dataTestId,
    } = props;

    const dispatch = useDispatch();
    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);

    const isCurrentMemberAdmin = event && isOrganizer(event);
    const canEditWeatherUpdate = isCurrentMemberAdmin;

    const onEditClick = () => {
        onEditWeatherNotification(notification);
    };

    const onDeleteClick = () => {
        setShowDeleteConfirmPopup(true);
    };

    const onDeleteConfirmation = () => {
        dispatch(deleteWeatherNotification(event.id, notification.id));
        setShowDeleteConfirmPopup(false);
    };

    return (
        <div className={styles.notification}>
            <div className={`d-flex mw0`}>
                <p className={`flex-1 ellipsis ${styles.time}`} title={notification.dateLastUpdatedTimeZone} data-testid={dataTestId && `${dataTestId}.time`}>
                    {notification.dateLastUpdatedTimeZone}
                </p>
                {canEditWeatherUpdate && (
                    <p className={styles.highlight}>
                        <span
                            className="mr4"
                            onClick={onEditClick}
                            data-testid={dataTestId && `${dataTestId}.edit-btn`}
                        >
                            Edit
                        </span>
                        <span>
                            |
                        </span>
                        <span
                            className="ml4"
                            onClick={onDeleteClick}
                            data-testid={dataTestId && `${dataTestId}.delete-btn`}
                        >
                            Delete
                        </span>
                    </p>
                )}
            </div>
            <p className={styles.description} data-testid={dataTestId && `${dataTestId}.description`}>
                {notification.notificationText}
            </p>
            {showDeleteConfirmPopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowDeleteConfirmPopup(false);
                    }}
                    onCtaClick={onDeleteConfirmation}
                    confirmationTitle={'Delete weather update'}
                    confirmationMessage={'Are you sure?'}
                    data-testid={dataTestId && `${dataTestId}.delete-popup`}
                />
            )}
        </div>
    );
};

export default Notification;

Notification.defaultProps = {
    'data-testid': null,
};

Notification.propTypes = {
    event: PropTypes.objectOf(any).isRequired,
    notification: PropTypes.shape({
        id: PropTypes.string.isRequired,
        notificationText: PropTypes.string.isRequired,
        dateLastUpdatedTimeZone: PropTypes.string.isRequired,
    }).isRequired,
    onEditWeatherNotification: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};
